import { render, staticRenderFns } from "./StockClosingList_Action.vue?vue&type=template&id=a61faaa2&"
import script from "./StockClosingList_Action.vue?vue&type=script&lang=js&"
export * from "./StockClosingList_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports